import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function PrivateRoute({Component}) {
  const navigate = useNavigate();

  useEffect(() => {
    const loginToken = sessionStorage.getItem("token");

    if (!loginToken) {
      navigate("auth/login");
    }
  }, []);

  return (
    <div>
      <Component />
      
    </div>
  );
}